{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "Použít",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "LAST_7_DAYS": "Posledních 7 dní",
      "LAST_30_DAYS": "Posledních 30 dní",
      "LAST_3_MONTHS": "Poslední 3 měsíce",
      "LAST_6_MONTHS": "Posledních 6 měsíců",
      "LAST_YEAR": "Poslední rok",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "Vlastní časové rozmezí"
    }
  }
}
